import React from 'react';

import { withTheme } from 'emotion-theming';
import { lighten } from 'polished';

import {
  BREAKPOINTS,
  INNER_GUTTER,
  OUTER_GUTTER,
  getColWidthCalc,
  unit,
} from '@zego/theme';

import ContentContainer from '@zego/components/ContentContainer';
import SectionDisplay from '@zego/components/SectionDisplay';
import StaticImage from '@zego/components/StaticImage';

import Mitochondria from '@zego/static/svgs/Mitochondria.svg';

const RightFeature = ({ image, children, theme: { tintColor } }) => (
  <SectionDisplay>
    <ContentContainer>
      <div
        css={{
          [BREAKPOINTS.medium]: {
            paddingTop: unit(18),
            paddingBottom: unit(18),
            position: 'relative',
            display: 'flex',
            flexDirection: 'row-reverse',
            alignItems: 'center',
          },
        }}
      >
        <div
          css={{
            paddingBottom: unit(12),
            [BREAKPOINTS.medium]: {
              paddingBottom: 0,
              width: getColWidthCalc(12, 20, 4),
              marginLeft: `calc(${INNER_GUTTER}px + ${getColWidthCalc(
                12,
                20,
                2,
              )})`,
            },
          }}
        >
          {children}
        </div>
        <div
          css={{
            '::before': {
              zIndex: -1,
              content: '""',
              position: 'absolute',
              background: `url(${Mitochondria}) no-repeat, linear-gradient(to right, ${lighten(
                0.1,
                tintColor,
              )}, ${tintColor})`,
              backgroundSize: `100% 100%, calc(100% - 2px) calc(100% - 2px)`,
              backgroundPosition: `0 0, 1px 1px`,
              backgroundRepeat: `no-repeat, no-repeat`,
              WebkitBackfaceVisibility: 'hidden',

              ...(image
                ? {
                    width: '100vw',
                    height: '67vw',
                    top: 0,
                    right: 0,
                    left: 'auto',
                    transform: 'scaleX(1.4) scaleY(-1.4) rotate(15deg)',
                  }
                : {
                    width: 500,
                    height: 335,
                    top: -138,
                    left: 0,
                    right: 'auto',
                    transform: `scaleX(0.8) scaleY(-0.8) rotate(15deg)`,
                  }),

              [BREAKPOINTS.medium]: {
                width: 970,
                height: 650,
                marginTop: -650 / 2,
                top: '50%',
                right: 0,
                left: 'auto',
                transform: `scaleX(1) scaleY(1) rotate(15deg) translateX(-50px) translateY(50px)`,
              },
            },
            position: 'relative',
            direction: 'rtl',
            [BREAKPOINTS.medium]: {
              width: `calc(${INNER_GUTTER}px + ${getColWidthCalc(12, 20, 6)})`,
            },
          }}
        >
          {image ? (
            <StaticImage
              alt=""
              src={image}
              ratio={1.5}
              css={{
                display: 'block',
                width: `calc(100% + ${OUTER_GUTTER}px)`,
                minWidth: 340,
                position: 'relative',
                right: -OUTER_GUTTER,
                borderRadius: '4px 0 0 4px',
                [BREAKPOINTS.medium]: {
                  borderRadius: 4,
                  right: 0,
                  top: 0,
                  boxShadow: '0 10px 100px 0 rgba(0, 0, 0, .25)',
                },
              }}
            />
          ) : null}
        </div>
      </div>
    </ContentContainer>
  </SectionDisplay>
);

export default withTheme(RightFeature);
